import React from 'react'
import Navbar from '../../component/Other/Navbar'
import Contact from '../../component/Page/Contact'
import Footer from '../../component/Page/Footer'
import Seen from '../../component/Page/Seen'
import Testimonial from '../../component/Page/Testimonial'

const ServiceDetaiPlanning = () => {
    return (
        <div className="overflow-hidden">
            <div className="position-relative">
                <Navbar />

                <div className="wrapper__video-bg">
                    <div className="bgwrap detail"></div>
                    <img src="./../../images/ssfdsf.png" className="ornament" alt="" />
                </div>
                <section className="position-relative z-2 section__home">
                    <div className="container h-100 position-relative">
                        <div className="d-flex align-items-center justify-content-center position-relative z-2 h-100">
                            <div className="text-center">
                                <div className="d-flex align-items-center justify-content-center normal font__size--24 text__24-1024 text-capitalize color__white mb-3">
                                    <img src="./../../images/ffsd (3).png" alt="" />
                                    <span className="mx-3">Planning</span>
                                    <img src="./../../images/ffsd (2).png" alt="" />
                                </div>
                                <h1 className="medium font__size--56 text__50-1024 text__50-sm text__50-xs play color__white mb-0">Planning a schedule that runs smoothly on <br className='d-none d-lg-block' /> their wedding day.</h1>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <section>
                <div className="container">
                    <div className="d-flex align-items-center normal font__size--24 text__24-1024 text__24-sm text-capitalize color__brown mb-3">
                        <img src="./../images/Vector 2.png" alt="" />
                        <span className="mx-2 mx-md-3">What we offer</span>
                        <img src="./../images/Vector 1.png" alt="" />
                    </div>
                    <h2 className="semi-bold font__size--32 text__32-1024 play mb-5">Our can help couples determine their wedding <br /> theme or concept and create suitable decoration and <br className='d-none d-md-block' /> invitation designs.</h2>


                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>1. Website Design</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                    <hr className='my-5 hr__footer' />
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>2. Wedding Concept Design</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                    <hr className='my-5 hr__footer' />
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>3. Invitation Design</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                    <hr className='my-5 hr__footer' />
                    <div className="row">
                        <div className="col-md-4">
                            <h4 className='semi-bold font__size--24 text__24-1024 play'>4. Style Consultation</h4>
                        </div>
                        <div className="col-md-8">
                            <p className='normal font__size--18 text__18-1024 color__gray-1'>Enim eu cras gravida ultricies. Pulvinar nec erat praesent nisi faucibus arcu viverra a mi. Faucibus posuere sit nibh tristique tortor massa at non. Sapien sed pretium amet blandit non porttitor dictumst. </p>
                        </div>
                    </div>
                </div>
            </section>

            <Seen />

            <Testimonial />

            <Contact />

            <Footer />
        </div >
    )
}

export default ServiceDetaiPlanning